import { CheckStatus, Parse, ParseText, HandleConflict, fetchAndParse } from '../utils/ajax';

export default {
    getActivated(tenantId) {
        return fetch('/api/run/1/flow', {
            headers: {
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getFlows(tenantId, authenticationToken) {
        return fetch('/api/draw/1/flow/', {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getLatest(id, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${id}`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getSnapshots(id, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/snap/${id}`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    addElement(request, elementId, flowId, elementType, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/element/flow/${flowId}/${elementType}/${elementId}`, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
            body: JSON.stringify(request),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    setLatest(flowData, tenantId, authenticationToken) {
        return fetch('/api/draw/1/flow', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
            body: JSON.stringify(flowData),
        })
            .then(CheckStatus)
            .then(Parse);
    },

    activateFlowSnapshot(flowId, versionId, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/activation/${flowId}/${versionId}/true/true`, {
            method: 'post',
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    exportFlow(id, tenantId, authenticationToken, includePasswords) {
        return fetch(`/api/package/1/flow/${id}/?nullPasswords=${!includePasswords}`, {
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(ParseText);
    },

    shareFlow(id, tenantId, authenticationToken, includePasswords) {
        return fetch(`/api/package/1/flow/${id}/share?nullPasswords=${!includePasswords}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    importFlow(json, tenantId, authenticationToken, force) {
        return fetch(`/api/package/1/flow${!force ? '?overwriteExisting=false' : ''}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
            body: json,
        })
            .then(HandleConflict)
            .then(CheckStatus)
            .then(Parse);
    },

    importSharedFlow(token, tenantId, authenticationToken, force) {
        return fetch(`/api/package/1/shared/flow${!force ? '?overwriteExisting=false' : ''}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
            },
            body: JSON.stringify({
                token,
            }),
        })
            .then(HandleConflict)
            .then(CheckStatus)
            .then(Parse);
    },

    getFlowSharedElements(flowId, elementType, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/element/flow/${flowId}/${elementType}`, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    deleteFlow(id, tenantId, authenticationToken) {
        return fetch(`/api/draw/1/flow/${id}`, {
            method: 'DELETE',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        })
            .then(CheckStatus)
            .then(Parse);
    },

    getNavigationElements({ authenticationToken, tenantId, flowId, editingToken, navigationElementId = null }) {
        return fetchAndParse({
            url: `/api/draw/1/flow/${flowId}/${editingToken}/element/navigation/${navigationElementId ?? ''}`,
            method: 'GET',
            headers: {
                ManyWhoTenant: tenantId,
                Authorization: authenticationToken,
            },
        });
    },
};
